import { cn } from "@/utils/cn";
import { IonSkeletonText } from "@ionic/react";

interface MealPreferenceListLoadingProps {
  className?: string;
}

export const MealPreferenceListLoading = ({
  className,
}: MealPreferenceListLoadingProps) => (
  <div className={cn("flex flex-col gap-2.5 pb-safe", className)}>
    {[0, 1, 2].map((index) => (
      <div
        key={index}
        className="flex items-center gap-4 rounded-3xl border border-white/10 bg-white px-3 py-2 min-h-[72px]"
      >
        <IonSkeletonText className="w-16 h-16 rounded-2xl" animated />
        <div className="flex-1 min-w-0">
          <IonSkeletonText className="w-3/4 h-5 rounded-xl" animated />
        </div>
      </div>
    ))}
  </div>
);
